import React, { useEffect, useState } from 'react';
import { Modal, Descriptions, Divider, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { 
    onSnapshot, 
    collection, 
    query as queryFirestore, 
    where,
} from "firebase/firestore";
import { useHistory } from 'react-router-dom';
import { firestore } from '../../services/firebase';
import { formatDate } from '../../utilities';

const ModalInfo = ( props ) => {


    const { handleCancel, modalData, isModalVisible } = props;
    const { autor, descripcion, fecha_alta, horario, id , nombre } = modalData;
    const history = useHistory();
    const [ visitas, setVisitas ] = useState(null);
    const [ loading, setLoading ] = useState(true);


    useEffect( () => {
        if( id ) { 
            const q = queryFirestore(collection(firestore, "contador"), where("idVideo", "==", id));
            onSnapshot(q, (querySnapshot) => {
                const videosInfo = [];
                let count = 0;
                querySnapshot.forEach((doc) => {
                    if( doc.data().idUsuario  ) {
                        videosInfo.push(doc.data());
                        count++;
                    }
                });
                setVisitas(count);
                setLoading(false);
            });
        }
    }, [ id ] );

    return (
        <Modal 
            loading={loading}
            title={nombre} 
            visible={isModalVisible} 
            onOk="false"
            onCancel={handleCancel}
            width={1000}
            footer={[
                <Button key="cerrar" onClick={handleCancel}> Cerrar</Button>,
              ]}
        >
            <Descriptions 
                layout="vertical"
            >
                <Descriptions.Item label="Autor">{ autor }</Descriptions.Item>
                <Descriptions.Item label="Horario">{ formatDate(horario?.toDate() )  }</Descriptions.Item>
                <Descriptions.Item label="Fecha de subida">{ formatDate(fecha_alta?.toDate())  }</Descriptions.Item>
                <Descriptions.Item label="Visitas">{ visitas  }</Descriptions.Item>
                <Descriptions.Item label="">{   }</Descriptions.Item>
                <Descriptions.Item> 
                    <Button 
                        icon={<UserOutlined />} 
                        size="large" 
                        type="primary"
                        onClick={ () => history.push(`/admin/visitas?id=${id}`) }
                    > Ver usuarios  
                    </Button> 
                </Descriptions.Item>
            </Descriptions>
            <Divider dashed />
            <p>{descripcion}</p>
        </Modal>
    )
}

export default ModalInfo
